const DEFAULT_LOCALE = 'en-IE';
const DEFAULT_CURRENCY = 'EUR';

const currencyFormatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
  style: 'currency',
  currency: DEFAULT_CURRENCY,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatCurrency = (amount: number, currency: string = DEFAULT_CURRENCY): string => {
  if (currency === DEFAULT_CURRENCY) {
    return currencyFormatter.format(amount);
  }

  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatCurrencyCompact = (
  amount: number,
  currency: string = DEFAULT_CURRENCY
): string => {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency,
    notation: 'compact',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};


